import { render, staticRenderFns } from "./RestaurantModal.vue?vue&type=template&id=bf75131e&scoped=true&"
import script from "./RestaurantModal.vue?vue&type=script&lang=js&"
export * from "./RestaurantModal.vue?vue&type=script&lang=js&"
import style0 from "./RestaurantModal.vue?vue&type=style&index=0&id=bf75131e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf75131e",
  null
  
)

export default component.exports